import Konva from "konva";
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";

export default class ToFrontLayer {
  constructor(layer) {
    this.layer  = layer;
    this.loaded = false;
    this.isShow = false;
    DrawEvent.on(drawEventType.TO_FRONT, ()=> {
      this.onToFront();
    });
  }
  load(url) {
    if (this.loaded) return;
    Konva.Image.fromURL(url, (image)=>{
      this.image = image;
      this.layer.add(image);
      this.layer.draw();
      this.loaded = true;
      if (this.isShow)
        this.show();
    });
  }

  show() {

    this.isShow = true;
    if (!this.image) return;
    this.image.opacity(0);
    this.tween = new Konva.Tween({
      node: this.image,
      easing: Konva.Easings.EaseInOut,
      duration: 2,
      opacity: 1,
      yoyo: true,
    });
    this.tween.play();
  }

  hide() {
    this.isShow = false;
    this.killTween();
  }
  killTween() {
    if (this.tween) {
      this.tween.destroy();
      this.tween = null;
    }
  }
  onToFront() {
    this.killTween();
    if (!this.image)
      return;
    this.tween = new Konva.Tween({
      node: this.image,
      easing: Konva.Easings.EaseInOut,
      duration: 1,
      opacity: 1
    });
    this.tween.play();
  }
}
